import React, { forwardRef } from "react";
import { Link } from "react-router-dom";
export const ReactRouterLink = forwardRef(({ to, children, ...rest }, ref) => (React.createElement(Link, { to: to, ref: ref, ...rest }, children)));
//# sourceMappingURL=ReactRouterLink.js.map